import { Box, useClipboard } from '@chakra-ui/react';
import { Button, IconButton, useSnackbar } from 'ui-components';
import { EmailIcon } from '~/components/icons';

export const ContactBtn = ({ email }: { email: string }) => {
  const snackbar = useSnackbar();
  const { onCopy } = useClipboard(email);

  const handleCopy = () => {
    onCopy();
    snackbar.success({ description: 'Email copied to clipboard' });
  };
  return (
    <>
      <Box
        display={{
          base: 'none',
          md: 'block',
        }}
      >
        <Button
          aria-label="contact manager"
          leftIcon={<EmailIcon />}
          variant="tertiary"
          sx={{
            width: '160px',
            flexShrink: 0,
            backgroundColor: 'var(--media-kit-button-background-default)',
            color: 'var(--media-kit-button-text)',
            _hover: {
              backgroundColor: 'var(--media-kit-button-background-hover)',
              color: 'var(--media-kit-button-text)',
            },
          }}
          onClick={handleCopy}
          track-id="contact-manager-btn"
        >
          Contact
        </Button>
      </Box>
      <Box
        display={{
          base: 'block',
          md: 'none',
        }}
      >
        <IconButton
          aria-label="delete"
          icon={<EmailIcon />}
          variant="tertiary"
          size="md"
          onClick={handleCopy}
          track-id="contact-manager-btn"
        />
      </Box>
    </>
  );
};
